import { render } from "./USWDSTextInput.vue?vue&type=template&id=65407046&scoped=true"
import script from "./USWDSTextInput.vue?vue&type=script&lang=js"
export * from "./USWDSTextInput.vue?vue&type=script&lang=js"

import "./USWDSTextInput.vue?vue&type=style&index=0&id=65407046&scoped=true&lang=scss"

import exportComponent from "/builds/wma/osd/decap/configuration-depot/configuration-depot-application/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65407046"]])

export default __exports__